import React, { useEffect, useState } from "react";
import "../../Style.css";
import Header from "../Header";
import Sidebar from "../Sidebar";
import Footer from "../Footer";
import { format } from "date-fns";
import {
  getMyMessages,
  createQuery,
  answerQuery,
} from "../../services/communicationService";
import { toast } from "react-toastify";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { getUserInfo } from "../../utils/auth";
import CryptoJS from "crypto-js";

export default function CommunicationList() {
  const [messages, setMessages] = useState([]);
  const [createTicket, setCreateTicket] = useState(false);
  const [communicationQuery, setCommunicationQuery] = useState("");
  const [currentMsg, setCurrentMsg] = useState("");
  const [communicationAnswer, setCommunicationAnswer] = useState("");
  const [replyBox, setReplyBox] = useState(false);
  const [userInfo, setUserInfo] = useState("");

  const handleProductClose = () => {
    setCreateTicket(false);
    setReplyBox(false);
  };

  useEffect(() => {
    getMyMessages().then((res) => {
      setMessages(res.data);
    });
  }, []);

  const getLocalDate = (createdAt) => {
    const date = new Date(createdAt);
    return format(date, "MMMM do, yyyy H:mm a");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (communicationQuery.trim() == "") {
      toast.error("Please specify your query !");
      return false;
    }

    let createdBy = "USER";
    let apiResult = await createQuery(createdBy, communicationQuery);

    if (apiResult.success) {
      toast.success("Your query has been sent, successfully.");
      setCommunicationQuery("");
      getMyMessages().then((res) => {
        setMessages(res.data);
      });
      handleProductClose();
    } else {
      toast.error("Failed to create query ticket, Please try again.");
    }
  };

  /**
   * Support Ticket Reply
   */

  const ticketReply = (msg) => {
    setCurrentMsg(msg);
    setReplyBox(true);
  };

  const handleReplySubmit = async (e) => {
    e.preventDefault();

    if (communicationAnswer.trim() == "") {
      toast.error("Please specify your answer !");
      return false;
    }

    let messageId = currentMsg.id;
    let apiResult = await answerQuery(messageId, communicationAnswer);

    if (apiResult.success) {
      toast.success("Answer has been saved, successfully.");
      setCommunicationAnswer("");
      handleProductClose();
      getMyMessages().then((res) => {
        setMessages(res.data);
      });
    } else {
      toast.error("Failed to create query ticket, Please try again.");
    }
  };

  const setUserDetails = () => {
    const userInfo = getUserInfo();
    const ENCRYPT_DECRYPTION_KEY = process.env.REACT_APP_ENCRYPTION_KEY;
    const bytes = CryptoJS.AES.decrypt(userInfo, ENCRYPT_DECRYPTION_KEY);
    const decryptedUserDetails = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    setUserInfo(decryptedUserDetails);
  };

  useEffect(() => {
    setUserDetails();
  }, []);

  return (
    <>
      <Header />
      <div className="container-fluid">
        <div className="row">
          <Sidebar />
          <main
            className="col-md-9 ms-sm-auto col-lg-10 px-md-4"
            style={{ paddingTop: "50px" }}
          >
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-6 bg-light">
                  <h3>My Communications</h3>
                </div>
                <div className="col-md-6">
                  <button
                    className="btn btn-primary"
                    onClick={(e) => setCreateTicket(true)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-file-earmark-plus"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 6.5a.5.5 0 0 1 .5.5v1.5H10a.5.5 0 0 1 0 1H8.5V11a.5.5 0 0 1-1 0V9.5H6a.5.5 0 0 1 0-1h1.5V7a.5.5 0 0 1 .5-.5" />
                      <path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5z" />
                    </svg>{" "}
                    Create Communication Ticket
                  </button>
                </div>
              </div>

              <div className="row">
                {messages.map((msg) => (
                  <div
                    key={msg.id}
                    className="card"
                    style={{ width: "18rem", margin: "20px" }}
                  >
                    <div className="card-body">
                      <h5 className="card-title">{msg.question}</h5>
                      <span>{getLocalDate(msg.createdAt)}</span>
                    </div>

                    <ul className="list-group list-group-flush">
                      <li className="list-group-item">
                        <p style={{ whiteSpace: "pre-wrap" }}>{msg.answer}</p>
                      </li>

                      <li className="list-group-item">
                        {msg.answeredAt != null && (
                          <span>{getLocalDate(msg.answeredAt)}</span>
                        )}
                      </li>
                      <li className="list-group-item">
                        {msg.closed ? (
                          <button className="btn btn-success">Closed</button>
                        ) : (
                          <div>
                            <button className="btn btn-warning">Open</button>

                            {userInfo.role == "ROLE_SUPER_ADMIN" && (
                              <div>
                                <button
                                  className="btn btn-primary"
                                  onClick={(e) => ticketReply(msg)}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    className="bi bi-reply"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M6.598 5.013a.144.144 0 0 1 .202.134V6.3a.5.5 0 0 0 .5.5c.667 0 2.013.005 3.3.822.984.624 1.99 1.76 2.595 3.876-1.02-.983-2.185-1.516-3.205-1.799a8.7 8.7 0 0 0-1.921-.306 7 7 0 0 0-.798.008h-.013l-.005.001h-.001L7.3 9.9l-.05-.498a.5.5 0 0 0-.45.498v1.153c0 .108-.11.176-.202.134L2.614 8.254l-.042-.028a.147.147 0 0 1 0-.252l.042-.028zM7.8 10.386q.103 0 .223.006c.434.02 1.034.086 1.7.271 1.326.368 2.896 1.202 3.94 3.08a.5.5 0 0 0 .933-.305c-.464-3.71-1.886-5.662-3.46-6.66-1.245-.79-2.527-.942-3.336-.971v-.66a1.144 1.144 0 0 0-1.767-.96l-3.994 2.94a1.147 1.147 0 0 0 0 1.946l3.994 2.94a1.144 1.144 0 0 0 1.767-.96z" />
                                  </svg>
                                  Reply
                                </button>
                              </div>
                            )}
                          </div>
                        )}
                      </li>
                    </ul>
                  </div>
                ))}
              </div>
            </div>
          </main>
        </div>
      </div>

      <Footer />

      <Modal show={createTicket} onHide={handleProductClose} size="lg">
        <Modal.Header>
          <Modal.Title>Raise a Support Ticket</Modal.Title>
          <button
            type="button"
            className="btn-close"
            onClick={handleProductClose}
          >
            X
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="card p-2">
            <div className="form-group">
              <div className="input-group col-sm-12">
                <div className="input-group col-sm-12">
                  <textarea
                    rows="5"
                    cols="33"
                    className="form-control"
                    value={communicationQuery}
                    onChange={(e) => setCommunicationQuery(e.target.value)}
                    required
                    placeholder="Type your question..."
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleProductClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleSubmit}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={replyBox} onHide={handleProductClose} size="lg">
        <Modal.Header>
          <Modal.Title>Reply</Modal.Title>
          <button
            type="button"
            className="btn-close"
            onClick={handleProductClose}
          >
            X
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="card p-2">
            <div className="form-group">
              <div className="input-group col-sm-12">
                <div className="row">
                  <h4>{currentMsg.question}</h4>
                </div>
                <div className="input-group col-sm-12">
                  <textarea
                    rows="10"
                    cols="50"
                    className="form-control"
                    value={communicationAnswer}
                    onChange={(e) => setCommunicationAnswer(e.target.value)}
                    required
                    placeholder="Type your answer..."
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleProductClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleReplySubmit}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
